import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PagamentoRegraComponent } from './pagamento-regra/pagamento-regra.component';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { TooltipModule } from 'primeng/tooltip';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { ToolbarModule } from 'primeng/toolbar';
import { DialogModule } from 'primeng/dialog';
import { RouterModule } from '@angular/router';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { BrowserModule } from '@angular/platform-browser';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { CheckboxModule } from 'primeng/checkbox';
import { SharedModule } from 'src/app/shared/shared.module';
import { ToastModule } from 'primeng/toast';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { PaginatorModule } from 'primeng/paginator';
import { DirectivesModule } from 'src/app/shared/directives/directives.module';



@NgModule({
  declarations: [PagamentoRegraComponent],
  imports: [
    PipesModule,
    TooltipModule,
    CommonModule,
    FormsModule,
    TableModule,    
    ButtonModule,
    InputTextModule,
    ToolbarModule,
    DialogModule,
    RouterModule,
    ConfirmDialogModule,
    RadioButtonModule,
    InputNumberModule,    
    BrowserModule,
    DividerModule,
    DropdownModule,
    CheckboxModule,
    SharedModule,
    ToastModule,
    BrowserAnimationsModule,
    PaginatorModule,
    DirectivesModule
    
  ],
  exports:[PagamentoRegraComponent]
})
export class PagamentoModule { }
